<!-- 阶梯价格表 -->
<template>
  <div v-if="list.length > 0" class="ladder-price">
    <div class="ladder-price__top" :class="{ 'is-fold': !isShowTable }">
      <div class="ladder-price__top__left">
        <span class="ladder-price__label">
          浮动阶梯价
        </span>
        <!-- 2/4/6层板爆款提示 -->
        <!-- 隐藏六层板惊爆价 -->
        <p v-if="hotFlag && hotFlag != 2" class="ladder-price__tips">
          <i></i>
          <template v-if="hotFlag == 3">
            {{ tips }}
          </template>
          <!-- <template v-else-if="hotFlag == 2">
            六层板惊爆价￥580/㎡，板材费<span>直降10%</span>
          </template> -->
          <template v-else-if="hotFlag == 1">
            四层板惊爆价￥400/㎡
          </template>
        </p>
        <p v-else-if="tips" class="ladder-price__tips">
          <i></i>
          {{ tips }}
        </p>
      </div>
      <div 
        class="ladder-price__top__right" 
        @click="() => isShowTable = !isShowTable"
      >
        <span>已折叠</span>
        <i class="el-icon-arrow-down"></i>
      </div>
    </div>
    
    <transition name="el-zoom-in-top">
      <div v-show="isShowTable" class="ladder-price__content">
        <el-table 
          border 
          v-loading="loading"
          class="ladder-price__table"
          :data="list" 
          :cell-class-name="cellClassName"
        >
          <template v-for="(item, index) in tableHead">
            <el-table-column 
              v-if="index === 0"
              align="center" 
              label="板厚/价格" 
              width="100"
              class-name="ladder-price__table__firstColumn"
              label-class-name="ladder-price__table__firstCell"
            >
              <template slot="header" slot-scope="scope">
                <div class="ladder-price__table__bias">
                    <div class="top">面积</div>
                    <div class="bottom">板厚</div>
                  </div>
              </template>
              <div slot-scope="{ row }">
                {{ (row[index] || {}).showTitle }}
              </div>
            </el-table-column>
            <el-table-column 
              v-else
              align="center"
              :min-width="50"
              :label="item.showTitle"
            >
              <div slot-scope="{ row }">
                {{ (row[index] || {}).showTitle }}
              </div>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </transition>
  </div>
</template>

<script>
import { debounce } from '@@/utils/utils'
import { getPriceList } from '@@/api/pcb'

export default {
  props: {
    // 获取阶梯价参数
    ladderPriceData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      isShowTable: true,
      tableHead: [],
      list: [],
      tips: '',
      hotFlag: false, // 是否显示4层板爆款提示
      debounceGetPirce: debounce(this.getList, 300), // 接口防抖
    }
  },
  watch: {
    ladderPriceData(newVal, oldVal) {
      const hasChange = Object.keys(newVal).some(key => newVal[key] != oldVal[key])
      if (hasChange) {
        this.debounceGetPirce()
      }
    }
  },
  mounted() {
    this.debounceGetPirce()
  },
  methods: {
    getList() {
      this.loading = true
      getPriceList(this.ladderPriceData)
        .then(res => {
          if (!res) return
          const data = res.data || {}
          const { tableHead, showList, tips, hotFlag } = data
          this.tableHead = tableHead || []
          this.list = showList || []
          this.tips = (tips || [])[0]
          this.hotFlag = hotFlag
          this.$emit('tipsChange', this.tips)
          this.$emit('change', this.list)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 当前/最惠class
    cellClassName({ row, column, rowIndex, columnIndex }) {
      const { now, max, hot, bgcolor } = row[columnIndex] || {}
      // 背景颜色
      let bgClass = bgcolor ? `bgcolor_${bgcolor}` : ''
      // 当前标识class
      if (now) return `ladder-price__table__icon now ${bgClass}`
      // 最惠标识class
      if (max) return `ladder-price__table__icon max ${bgClass}`
      // 爆款标识class
      if (hot) return `ladder-price__table__icon hot ${bgClass}`
      return bgClass || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.ladder-price {
  $backgroundColor: #F5F5F5;
  $borderColor: #D8D8D8;
  margin-top: 5px;
  border-radius: 3px;
  overflow: hidden;
  .ladder-price__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 12px;
    font-size: 12px;
    background-color: $backgroundColor;
    &.is-fold {
      .ladder-price__label {
        font-weight: 400;
      }
      .ladder-price__top__right {
        >span {
          display: inline-block;
        }
        >i {
          transform: rotate(-90deg);
        }
      }
    }
    .ladder-price__top__left {
      display: flex;
    }
    .ladder-price__top__right {
      flex: 1;
      padding-right: 12px;
      text-align: right;
      cursor: pointer;
      >span {
        display: none;
        margin-right: 6px;
        font-size: 12px;
        color: #BABABA;
      }
    }
    .ladder-price__label {
      margin-right: 12px;
      color: $--color-text-important;
      font-weight: 700;
    }
    .ladder-price__tips {
      display: flex;
      align-items: center;
      color: #AAAAAA;
      >i {
        margin-right: 6px;
        display: inline-block;
        width: 16px;
        height: 14px;
        background: url(~@@/assets/img/icons/icon_drop.png) no-repeat;
        background-size: 100% 100%;
      }
      >span {
        color: #E7001D;
      }
    }
  }
  .ladder-price__content {
    padding: 0 12px 12px;
    background-color: $backgroundColor;
  }
  .ladder-price__table {
    font-size: 12px;
    border-color: $borderColor;
    &::after,
    &::before {
      background-color: $borderColor;
    }
    ::v-deep {
      td, th {
        padding: 4px 0;
        font-weight: 400;
        color: #666666;
        border-color: $borderColor;
        >.cell {
          padding-left: 0;
          padding-right: 0;
        }
      }
      th,
      .ladder-price__table__firstColumn {
        background-color: #F5F7FA !important;
      }
      th {
        line-height: 20px;
      }
      .ladder-price__table__firstCell.is-leaf {
        position: relative;
        padding-left: 10px;
        padding-right: 10px;
        &::before {
          content: "";
          position: absolute;
          top: 1px;
          left: 0;
          display: block;
          width: 1px;
          height: 110px;
          background-color: $borderColor;
          transform: rotate(-73deg);
          transform-origin: top;
        }
      }
      .ladder-price__table__icon {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          width: 26px;
          height: 16px;
        }
        &.now::after {
          background: url(~@@/assets/img/icons/icon_ladder_price_now.png);
        }
        &.max::after {
          background: url(~@@/assets/img/icons/icon_ladder_price_max.png);
        }
        &.hot::after {
          background: url(~@@/assets/img/icons/icon_ladder_price_hot.png);
        }
        &.max {
          color: #F65001;
        }
      }
      .bgcolor_red {
        background-color: #FFF7F8;
      }
    }
    
    .ladder-price__table__bias {
      line-height: 1;
      font-size: 12px;
      .top {
        text-align: right;
        box-sizing: border-box;
      }
      .bottom {
        text-align: left;
        box-sizing: border-box;
      }
    }
  }
}
</style>